<template>
  <div class="warp">
    <div>{{msgObj.content}}
    </div>
  </div>
</template>

<script>
export default {
  props: ["msgObj"]
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  overflow: hidden;
  white-space: break-spaces;
}
</style>